import { BookOpen, MessageSquare, Shuffle, Sparkles, WandSparkles } from 'lucide-react';
import { useState } from 'react';

export type ScenarioSourceMode = 'template' | 'random_template' | 'freeform';
export type ScenarioKickoffMode = 'discuss' | 'auto';
export type ScenarioTemplateChoice = { id: string; title: string; description?: string; publicationState?: string };

export function ScenarioOnboarding({
  sourceMode,
  kickoffMode,
  templates,
  busy,
  onChooseSource,
  onChooseKickoff,
  autoLimit,
}: {
  sourceMode: ScenarioSourceMode | null;
  kickoffMode: ScenarioKickoffMode | null;
  templates: ScenarioTemplateChoice[];
  busy: boolean;
  onChooseSource: (mode: ScenarioSourceMode, templateId?: string) => void;
  onChooseKickoff: (mode: ScenarioKickoffMode) => void;
  autoLimit?: string | null;
}) {
  const [choosingTemplate, setChoosingTemplate] = useState(false);
  if (sourceMode && kickoffMode) return null;

  if (!sourceMode) {
    if (choosingTemplate) {
      return <section className="scenario-onboarding" aria-labelledby="scenario-template-choice-title">
        <header>
          <div><span>Шаг 1 из 2</span><h2 id="scenario-template-choice-title">Выберите шаблон</h2></div>
          <button type="button" className="secondary compact" disabled={busy} onClick={() => setChoosingTemplate(false)}>Назад</button>
        </header>
        <div className="scenario-template-choices">
          {templates.map(template => <button type="button" aria-label={template.title} key={template.id} disabled={busy} onClick={() => onChooseSource('template', template.id)}>
            <BookOpen />
            <span><b>{template.title}</b>{template.description && <small>{template.description}</small>}</span>
          </button>)}
          {!templates.length && <p className="muted">В общей библиотеке пока нет доступных шаблонов.</p>}
        </div>
      </section>;
    }
    return <section className="scenario-onboarding" aria-labelledby="scenario-source-title">
      <header><div><span>Шаг 1 из 2</span><h2 id="scenario-source-title">Как построить сценарий?</h2></div></header>
      <div className="scenario-onboarding-actions">
        <button type="button" aria-label="По шаблону" disabled={busy} onClick={() => setChoosingTemplate(true)}><BookOpen /><span><b>По шаблону</b><small>Выбрать структуру самостоятельно</small></span></button>
        <button type="button" aria-label="По случайному шаблону" disabled={busy || !templates.length} onClick={() => onChooseSource('random_template')}><Shuffle /><span><b>По случайному шаблону</b><small>Система выберет опубликованный шаблон</small></span></button>
        <button type="button" aria-label="В свободной форме" disabled={busy} onClick={() => onChooseSource('freeform')}><WandSparkles /><span><b>В свободной форме</b><small>Без сценарного шаблона</small></span></button>
      </div>
    </section>;
  }

  return <section className="scenario-onboarding" aria-labelledby="scenario-kickoff-title">
    <header><div><span>Шаг 2 из 2</span><h2 id="scenario-kickoff-title">Как начать работу?</h2></div></header>
    <div className="scenario-onboarding-actions two">
      <button type="button" aria-label="Обсудить проект" disabled={busy} onClick={() => onChooseKickoff('discuss')}><MessageSquare /><span><b>Обсудить проект</b><small>Рассказать идею и вместе собрать сценарий</small></span></button>
      <button type="button" aria-label="Сделать на усмотрение ИИ-агента" disabled={busy} onClick={() => onChooseKickoff('auto')}><Sparkles /><span><b>Сделать на усмотрение ИИ-агента</b><small>Агент сам выберет тему, персонажей и подготовит сценарий{autoLimit?` · Лимит ${autoLimit} кр.`:''}</small></span></button>
    </div>
  </section>;
}
